export const isDuplicateTemplateName = (name, templates, excludeTemplateId)=>{
    const normalized = name.trim().toLocaleLowerCase();
    if (normalized === '') return false;
    return templates.some((tmpl)=>tmpl.id !== excludeTemplateId && tmpl.name.trim().toLocaleLowerCase() === normalized);
};
